import { Phone } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { trackPhoneClick } from '@/lib/analytics';

const DEFAULT_PHONE = { display: '04 70 42 72 63', tel: '+33470427263' };

const CONTEXTUAL_PHONES = {
  '/ambulance-beaulon-garnat':      { display: '04 70 42 72 63', tel: '+33470427263' },
  '/celine-ambulance-diou':         { display: '04 70 42 90 08', tel: '+33470429008' },
  '/ambulance-tronget-le-montet':   { display: '04 70 47 10 30', tel: '+33470471030' },
};

export default function FloatingCallButton() {
  const { pathname } = useLocation();
  // Ambulance 03 landing has its own dedicated CTA with a different phone.
  if (pathname.startsWith('/ambulance-03-avermes')) return null;
  const phone = CONTEXTUAL_PHONES[pathname] || DEFAULT_PHONE;
  return (
    <a
      href={`tel:${phone.tel}`}
      aria-label={`Appeler maintenant ${phone.display}`}
      data-testid="floating-call-button"
      onClick={() => trackPhoneClick(`floating-${pathname === '/' ? 'home' : pathname.slice(1)}`, phone.display)}
      className="fixed z-40 bottom-40 md:bottom-24 right-4 md:right-6 inline-flex items-center gap-2.5 rounded-full bg-gradient-to-r from-brand-500 to-brand-700 hover:from-brand-600 hover:to-brand-800 text-white pl-3 pr-4 py-3 shadow-[0_12px_28px_rgba(31,122,174,0.45)] hover:shadow-[0_18px_38px_rgba(31,122,174,0.55)] ring-2 ring-white/40 transition-all duration-300 hover:scale-[1.03] focus-ring group"
    >
      <span className="relative flex items-center justify-center h-9 w-9 rounded-full bg-white/15 backdrop-blur">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-pulse-ring pointer-events-none"></span>
        <Phone className="h-4 w-4 fill-white" />
      </span>
      <span className="flex flex-col items-start leading-none">
        <span className="text-[10px] font-medium text-white/85 uppercase tracking-[0.14em]">Appeler maintenant</span>
        <span className="text-sm sm:text-base font-heading font-semibold tabular-nums whitespace-nowrap">{phone.display}</span>
      </span>
    </a>
  );
}
